export class ChannelTotals
{
    public programName = '';
    public programLead = '';
    public programLeadId = null;
    public leaderUserName = '';
    public programId = 0;
    public openCases = 0;
    public closedCases = 0;
    public lateTasks = 0;
}
